import { useOutletContext } from "react-router-dom";
import { Heading } from "V2.0/common/heading";
import CampaignSections from "./CampaignSections";

export default function Campaigns() {
  const { projectId, settings, fetchSettings, assistants, fetchAssistants, isViewOnly } = useOutletContext<{
    projectId: string;
    settings: object;
    fetchSettings: Function;
    assistants: object;
    fetchAssistants: Function;
    isViewOnly: boolean
  }>();

  return (
    <div className="flex flex-col h-full w-full">
      <div className="p-4 border-b">
        <Heading>Campaigns</Heading>
      </div>
      <div className="h-full w-full min-h-0 flex-1">
        <CampaignSections
          projectId={projectId}
          settings={settings}
          fetchSettings={fetchSettings}
          assistants={assistants}
          fetchAssistants={fetchAssistants}
          isViewOnly={isViewOnly}
        />
      </div>
    </div>
  );
}
